import { computed } from 'vue';
import { ModalStates } from '@/types/modal/modal.enum';
import { RemainingRouteNames } from '@/types/i-router';
import store from '@/store';

export default class AppComponent {
	public isModalActive = computed((): boolean => {
		const modalState = store.getters.modalState();
		return modalState === ModalStates.ACTIVE;
	});

	public routeIsListing = computed((): boolean => {
		const listingRoutes: string[] = [
			RemainingRouteNames.ORGANISATION_LISTING_OVERVIEW,
			RemainingRouteNames.STUDY_LISTING_OVERVIEW
		];
		return listingRoutes.includes(this.currentRoute.value);
	});

	private currentRoute = computed((): string => {
		const router = store.getters.router();
		return router.current;
	});
}
